import { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";

import { Button, ButtonGroup, Col, FormGroup, Label, Row } from "reactstrap";

import { GetLanguageString } from "../../../helper/Components";
import { ApiUnit } from "../../../unit/ApiUnit";

const SearchEventSummary = ({
  searchEventParticipants,
  setSearchEventParticipants,
  setSearchButton,
  eventUnitType,
}) => {
  const [initialUnitId] = useState(() => searchEventParticipants.unitId);
  const [values, setValues] = useState(searchEventParticipants);
  const [unitList, setUnitList] = useState([]);
  const [showAllUnits, setShowAllUnits] = useState("primary");
  const [showAllZones, setShowAllZones] = useState("white");
  const [showAllHalqas, setShowAllHalqas] = useState("white");
  const [showAllTanzeem, setShowAllTanzeem] = useState("white");
  const [showAllUsra, setShowAllUsra] = useState("white");
  const [unitType, setUnitType] = useState(eventUnitType);
  const unitTypeName = "null";

  useEffect(() => {
    ApiUnit()
      .getUnitList(initialUnitId, initialUnitId, false, unitTypeName, true)
      .then((res) => {
        setUnitList(res.data);
      })
      .catch((err) => console.log(err));
  }, [initialUnitId]);

  const handleChangeUnits = (record) => {
    if (record !== null) {
      ApiUnit()
        .getUnitList(record.value, initialUnitId, false, unitTypeName, true)
        .then((res) => {
          setUnitList(res.data);
        })
        .catch((err) => console.log(err));
      setValues({
        ...values,
        unitId: record.value,
        type: "None",
      });
      setShowAllZones("white");
      setShowAllUnits("primary");
      setShowAllHalqas("white");
      setShowAllTanzeem("white");
      setShowAllUsra("white");
      setUnitType(record.label1);
    } else {
      ApiUnit()
        .getUnitList(initialUnitId, initialUnitId, false, unitTypeName, true)
        .then((res) => {
          setUnitList(res.data);
        })
        .catch((err) => console.log(err));
      setValues({
        ...values,
        unitId: 0,
      });
    }
  };

  const handleShowUnitCheck = (e) => {
    const { value } = e.target;
    if (value === "0") {
      setShowAllZones("white");
      setShowAllUnits("primary");
      setShowAllHalqas("white");
      setShowAllTanzeem("white");
      setShowAllUsra("white");
      setValues({
        ...values,
        type: "None",
      });
    } else if (value === "1") {
      setShowAllZones("primary");
      setShowAllUnits("white");
      setShowAllHalqas("white");
      setShowAllTanzeem("white");
      setShowAllUsra("white");
      setValues({
        ...values,
        type: "Zone",
      });
    } else if (value === "2") {
      setShowAllZones("white");
      setShowAllUnits("white");
      setShowAllHalqas("primary");
      setShowAllTanzeem("white");
      setShowAllUsra("white");
      setValues({
        ...values,
        type: "Halqa",
      });
    } else if (value === "3") {
      setShowAllZones("white");
      setShowAllUnits("white");
      setShowAllHalqas("white");
      setShowAllTanzeem("primary");
      setShowAllUsra("white");
      setValues({
        ...values,
        type: "Tanzeem",
      });
    } else if (value === "4") {
      setShowAllZones("white");
      setShowAllUnits("white");
      setShowAllHalqas("white");
      setShowAllTanzeem("white");
      setShowAllUsra("primary");
      setValues({
        ...values,
        type: "Usra",
      });
    }
  };

  const handleSearch = () => {
    setSearchEventParticipants(values);
    setSearchButton(true);
  };

  return (
    <div className="ibox-content">
      <Row>
        {unitList.map((record, index) => {
          const unitOptions = [];
          record.unitList.forEach((d) =>
            unitOptions.push({
              value: d.id,
              label: d.name,
              label1: d.unitTypeName,
            })
          );
          let selected = {};
          let unitName = "";
          if (record.parentUnitName !== null) unitName = record.parentUnitName;
          if (record.selectedUnit !== null) {
            selected = {
              value: record.selectedUnit.id,
              label: record.selectedUnit.name,
            };
          }

          return (
            <>
              <Col md="2" key={index}>
                <FormGroup>
                  <Label className="col-form-label">
                    {unitName !== "" ? (
                      <GetLanguageString
                        props="member_select_unit_name"
                        value={unitName}
                      />
                    ) : (
                      <GetLanguageString props="member_select_unit" />
                    )}
                  </Label>
                  <Select
                    options={unitOptions}
                    value={selected}
                    className="basic-single ur"
                    classNamePrefix="select"
                    onChange={handleChangeUnits}
                  />
                </FormGroup>
              </Col>
            </>
          );
        })}
      </Row>
      <Row>
        <Col md="6">
          <ButtonGroup style={{ paddingTop: 32 }} className="text-center">
            {(unitType === "Markaz" ||
              unitType === "Zone" ||
              unitType === "Halqa") && (
              <Button
                color={showAllUnits}
                value={0}
                onClick={handleShowUnitCheck}
              >
                {<GetLanguageString props="report_member_show_all_units" />}
              </Button>
            )}
            {unitType === "Markaz" && (
              <Button
                color={showAllZones}
                value={1}
                onClick={handleShowUnitCheck}
              >
                {<GetLanguageString props="report_member_show_zones" />}
              </Button>
            )}
            {(unitType === "Markaz" || unitType === "Zone") && (
              <Button
                color={showAllHalqas}
                value={2}
                onClick={handleShowUnitCheck}
              >
                {<GetLanguageString props="report_member_show_halqa" />}
              </Button>
            )}
            {(unitType === "Markaz" ||
              unitType === "Zone" ||
              unitType === "Halqa") && (
              <Button
                color={showAllTanzeem}
                value={3}
                onClick={handleShowUnitCheck}
              >
                {<GetLanguageString props="report_member_show_tanzeem" />}
              </Button>
            )}
            {(unitType === "Markaz" ||
              unitType === "Zone" ||
              unitType === "Halqa") && (
              <Button
                color={showAllUsra}
                value={4}
                onClick={handleShowUnitCheck}
              >
                {<GetLanguageString props="report_member_show_usra" />}
              </Button>
            )}
          </ButtonGroup>
        </Col>
      </Row>
      <Row>
        <Col md="12" className="text-center m-t-sm">
          <Button color="primary" type="submit" onClick={handleSearch}>
            {<GetLanguageString props="funds_submit" />}
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default SearchEventSummary;
